import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CallInfo = _resolveComponent("CallInfo")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Hint = _resolveComponent("Hint")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["incoming-call", {'incoming-call-collapse': _ctx.settingsState.minimize}])
  }, [
    (!_ctx.settingsState.minimize)
      ? (_openBlock(), _createBlock(_component_CallInfo, {
          key: 0,
          incomingCall: true,
          callData: _ctx.currentIncomingCall
        }, null, 8, ["callData"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Hint, {
      class: "hint-number",
      text: _ctx.incomingCallsStore.length > 26 ? _ctx.currentIncomingCall.number : ''
    }, {
      default: _withCtx(() => [
        (_ctx.settingsState.minimize)
          ? (_openBlock(), _createBlock(_component_Typography, {
              key: 0,
              class: "title-number",
              fontColor: "--sui-green-900"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.currentIncomingCall.number), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["text"]),
    _createElementVNode("div", {
      class: _normalizeClass(["button-wrap", _ctx.buttonWrapClasses])
    }, [
      (_ctx.settingsState.minimize)
        ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_Hint, {
        class: "hint-button",
        text: _ctx.t('hints.decline')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "button close",
            mode: "alert",
            iconOnly: "",
            icon: {name: 'ic20-close', color: '--sui-white'},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hangUp({ id: _ctx.currentIncomingCall.id })))
          })
        ]),
        _: 1
      }, 8, ["text"]),
      (_ctx.currentIncomingCall.video)
        ? (_openBlock(), _createBlock(_component_Hint, {
            key: 1,
            class: "hint-button",
            text: _ctx.t('hints.answerVideo')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                class: "button take-call",
                mode: "primary",
                iconOnly: "",
                icon: { spriteUrl: 'static/icons-pack.svg', name: 'ic24-videocamera' },
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.answerCall(true)))
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Hint, {
        class: "hint-button",
        text: _ctx.t('hints.answer')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "button take-call",
            mode: "primary",
            iconOnly: "",
            icon: {name: 'ic20-phone', color: '--sui-white'},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.answerCall(false)))
          })
        ]),
        _: 1
      }, 8, ["text"])
    ], 2)
  ], 2))
}